import type React from "react";
import { getColor, type Props } from "~/components/icons/helper";

export const AllowUpIcon: React.FC<Props> = ({ color }) => {
	return (
		<svg
			role="img"
			aria-label="Allow Up"
			width="16"
			height="12"
			viewBox="0 0 16 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1 11L5.31672 2.36657C6.42229 0.155421 9.57771 0.155417 10.6833 2.36656L15 11"
				stroke={getColor(color)}
			/>
		</svg>
	);
};
